import React from "react";
import { findAllCompetencyPagedEvent, findAllCompetencyPagedLikeNameEvent } from "../../_events/competency/find.event";
import { alertError } from "../../_utils/alerts";

export const useCompetencyPaged = ({ page = 0, limit = 8 }) => {

    const [data, setData] = React.useState([]);

    const loadData = (p, l, filterName) => {
        if(filterName === '' || filterName === undefined || filterName === ''){
            findAllCompetencyPagedEvent(p, l)
            .then(json => {
                setData(json.paged);
            })
            .catch(err => {
                alertError(err.message);
            });
        } else {
            findAllCompetencyPagedLikeNameEvent(p, l, filterName)
            .then(json => {
                setData(json.paged);
            })
            .catch(err => {
                alertError(err.message);
            });
        }        
    }

    React.useEffect(() => {
        loadData(page, limit, '');
    }, [page, limit]);

    return { data, loadData };
}